export const actionCopyEs = {
    next: "Siguiente",
    back: "Atrás",
    save: "Guardar",
    send: "Enviar",
    skip: "Omitir",
    skipForNow: "Aún no lo sé",
    continue: "Continuar",
    cancel: "Cancelar",
    delete: "Eliminar",
    submit: "Enviar",
    confirm: "Confirmar",
    add: "Añadir",
    edit: "Editar",
    done: "Completado",
    stop: "Detener",
    retry: "Reintentar",
    download: "Descargar",
    apply: "Aplicar",
    filter: "Filtrar",
    filters: "Filtros",
    columns: "Columnas",
    close: "Cerrar",
    search: "Buscar",
    more: "Más",
    none: "Ninguno",
    previous: "Anterior",
    rename: "Renombrar",
    duplicate: "Duplicar",
    share: "Compartir",
    clearAll: "Borrar todo",
    clearSearch: "Borrar la búsqueda",
    loading: "Cargando...",
    open: "Abrir",
    invite: "Invitar",
    saveCorrection: "Guardar la corrección",
    saving: "Guardando...",
    sending: "Enviando...",
    submitting: "Enviando...",
    skipping: "Omitiendo...",
    goingBack: "Volviendo...",
    goingNext: "Pasando al siguiente...",
    cancelling: "Cancelando...",
    deleting: "Eliminando...",
    deleteConfirmTitle: "¿Está absolutamente seguro/a?",
    deleteConfirmDescription: "Esta acción es irreversible.",
    continuing: "Continuando...",
    confirming: "Confirmando...",
    adding: "Añadiendo...",
    editing: "Editando...",
    finishing: "Finalizando...",
    stopping: "Deteniendo...",
    retrying: "Reintentando...",
    downloading: "Descargando...",
};
